import React from 'react';
import clsx from "clsx";
import ExpandoMenu from '../../../../../../ui_components/ExpandoMenu/ExpandoMenu';
import ShowText from '../../../../../../shared_components/Info/ShowText/ShowText';
import ButtonSize from '../../../../../../ui_components/Button/ButtonSize';
import ButtonType from '../../../../../../ui_components/Button/ButtonType';
import { useStyles } from '../CustomCategorySalePrices.style';
import CustomCategorySalePriceRowProperties from './CustomCategorySalePriceRowProperties';
import ShowIntervalWithTitle from '../../../../../../shared_components/Info/ShowIntervalWithTitle/ShowIntervalWithTitle';
import { CurrencyModule } from '../../../../../../util/Currency';
import Currency from '../../../../../../entities/Currency';
import { useI18nContext } from '../../../../../../contexts/I18nContext';
import UpdatePackageCustomCategoryWeightRangeSalePriceButton from '../../../../../../shared_components/Buttons/UpdatePackageCustomCategoryWeightRangeSalePriceButton/UpdatePackageCustomCategoryWeightRangeSalePriceButton';

const CustomCategorySalePriceRowMedium: React.FC<CustomCategorySalePriceRowProperties> = ({
                                                            weightRange,
                                                            salePrice,
                                                            onUpdate = () => {
                                                            },
                                                        }) => {

    const classes = useStyles();
    const i18n = useI18nContext();

    const packageSalePrice = salePrice?.packageCustomCategoryWeightRangeSalePrices.find(t => t.customCategoryWeightRangeId === weightRange.id);

    return (
        <div className={clsx(classes.package_sale_prices_info_container)}>
            <ShowIntervalWithTitle title={i18n.translate("WEIGHT_RANGES_RANGE")} from={weightRange.from} to={weightRange.to}/>
            <ShowText text={CurrencyModule.format(packageSalePrice?.salePrice ?? 0, Currency.DOLLAR)} title={i18n.translate("WEIGHT_RANGES_PRICE")}/>
            <ExpandoMenu>
                <>
                    <UpdatePackageCustomCategoryWeightRangeSalePriceButton
                       size={ButtonSize.SMALL}
                       onSave={onUpdate}
                       showText
                       salePriceId={salePrice?.id ?? ''}
                       weightRangeId={weightRange.id}
                       value={packageSalePrice?.salePrice ?? 0}
                       type={ButtonType.SECONDARY}
                   />
                </>
            </ExpandoMenu>
        </div>
    )
}

export default CustomCategorySalePriceRowMedium;
